import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CalenderView, { weekdayDates } from "./calenderView/calenderView";
import { getUnAuthAppointments } from "../lib/api";
import { Drawer, DrawerContent, DrawerTrigger } from "./ui/Drawer";
import { EventDetail } from "./calenderView/event/EventDetail";
import { subDays } from "date-fns";

const AppointmentRequest = () => {
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("user_id");
  const appointmentId = new URLSearchParams(location.search).get(
    "appointment_id"
  );
  const [selected, setSelected] = useState(new Date());
  const [appointments, setAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [open, setOpen] = useState(false);
  const args = {
    startHour: 8,
    endHour: 17,
    hoverEventDuration: 60,
  };
  async function fetchAppointments() {
    try {
      const payload = {
        user_id: userId,
        status: "requested",
        // startDate: weekdayDates(0, selected).startDate,
        // endDate: weekdayDates(0, selected).endDate,
      };
      const response = await getUnAuthAppointments(payload);
      const appointments = response?.data?.result || [];
      // console.log(appointments, "appointments");
      setAppointments(appointments);
      const selectedAppointment = appointments?.filter(e => e?.id === appointmentId);
      if(selectedAppointment?.length > 0){
        setSelected(subDays(new Date(selectedAppointment[0].start_time),1))
        setSelectedAppointment(selectedAppointment[0]);
        setOpen(true)
      }
      
    } catch (error) {
      console.error("Error fetching location data:", error);
      return null;
    }
  }

  useEffect(() => {
    fetchAppointments();
  }, []);

  return (
    <div className="bg-gray-50 min-sh-screen">
      <CalenderView
        {...args}
        events={appointments}
        onEventClick={(e) => {
          setSelectedAppointment(e);
          setOpen(true);
        }}
        onEmptyCellClick={(date) => alert(date.toString())}
        sortEvents
        startDate={weekdayDates(0, selected).startDate}
        endDate={weekdayDates(0, selected).endDate}
      />
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild></DrawerTrigger>
        <DrawerContent>
          <EventDetail event={selectedAppointment} onHandleClose={() => setOpen(false)} />
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default AppointmentRequest;
